import { render, staticRenderFns } from "./systemrecharge.vue?vue&type=template&id=0d0650d1&scoped=true&"
import script from "./systemrecharge.vue?vue&type=script&lang=ts&"
export * from "./systemrecharge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0650d1",
  null
  
)

export default component.exports